import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { environment } from '@env/environment';
import { Logger, untilDestroyed } from '@core';
import { AuthenticationService } from './authentication.service';
import { TranslateService } from '@ngx-translate/core';

const log = new Logger('Login');

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [MessageService],
})
export class LoginComponent implements OnInit, OnDestroy {
  version: string | null = environment.version;
  error: string | undefined;
  loginForm!: FormGroup;
  isLoading = false;
  fieldPasswordType: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private messageService: MessageService,
    private translate: TranslateService
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params.registered !== undefined && params.registered === 'true') {
        this.messageService.add({
          key: 'register',
          severity: 'success',
          summary: this.translate.instant('Success'),
          detail: this.translate.instant('Registration-Success'),
        });
      }
    });
  }

  ngOnDestroy() {}

  onSubmit() {
    this.authenticationService.login(this.loginForm.value).subscribe(
      (res: any) => {
        let item = 'temp_pass';
        if (res[item]) {
          this.messageService.add({
            key: 'login',
            severity: 'success',
            summary: this.translate.instant('Success'),
            detail: this.translate.instant('SignIn-Success'),
          });
          setTimeout(() => {
            this.router.navigate(['/reset-password'], { relativeTo: this.route });
          }, 1000);
        } else {
          this.messageService.add({
            key: 'login',
            severity: 'success',
            summary: this.translate.instant('Success'),
            detail: this.translate.instant('SignIn-Success'),
          });
          setTimeout(() => {
            window.location.href = '/home';
            //this.router.navigate(['/home']);
          }, 1000);
        }
        localStorage.setItem('token', res.csrf_token);
        if (localStorage.getItem('language') === null) {
          localStorage.setItem('language', 'en');
        }
      },
      (err) => {
        if (err.status === 400) {
          // this.toastr.error('Incorrect username or password.', 'Authentication failed.');
          this.messageService.add({
            key: 'login',
            severity: 'error',
            summary: 'Error',
            detail: err.message,
          });
        } else {
          console.log(err);
        }
      }
    );
  }
  togglePasswordType() {
    this.fieldPasswordType = !this.fieldPasswordType;
  }
  private createForm() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      remember: true,
    });
  }
}
